// Bump this on every meaningful change so the deployed build is identifiable at a glance.
export const BUILD = "v7 · 2026-07-29";
